import * as types from '../mutation-types.js';

const state = () => ({
  // 用户姓名
  name: '测试',
  // 员工id
  userId: 1637377575,
  // api调用token,aa免登录
  // token: 'aa',
  token: 'ODI5Mjg0OTk4ODc5MTc0NjU2',
  // 广场Id
  plazaId: 1002294,
  // 广场名称
  plazaName: '北京丰科万达广场',
  // 租户Id
  tenantId: 2021072700038,
  // 角色类型
  roleType: 1,
  // 店铺id
  storeId: 3062954,
  // 电话号
  mobile: '1777777777',
});

const getters = {
  token: state => {
    return state.token;
  },
  userCode: state => {
    return state.userCode;
  },
  userId: state => {
    return state.userId;
  },
  plazaId: state => {
    return state.plazaId;
  },
  plazaName: state => {
    return state.plazaName;
  },
  userName: state => {
    return state.userName;
  },
  name: state => {
    return state.name;
  },
  tenantId: state => {
    return state.tenantId;
  },
  roleType: state => {
    return state.roleType;
  },
  storeId: state => {
    return state.storeId;
  },
  mobile: state => {
    return state.mobile;
  },
};

const mutations = {
  [types.ACCOUNT_TOKEN](state, data) {
    state.token = data;
  },
  [types.ACCOUNT_USER_ID](state, data) {
    state.userId = data;
  },
  [types.ACCOUNT_PLAZA_ID](state, data) {
    state.plazaId = data;
  },
  [types.ACCOUNT_PLAZA_NAME](state, data) {
    state.plazaName = data;
  },
  [types.ACCOUNT_ROLE_TYPE](state, data) {
    state.roleType = data;
  },
  [types.ACCOUNT_NAME](state, data) {
    state.name = data;
  },
  [types.ACCOUNT_TENANT_ID](state, data) {
    state.tenantId = data;
  },
  [types.ACCOUNT_STORE_ID](state, data) {
    state.storeId = data;
  },
  [types.ACCOUNT_MOBILE](state, data) {
    state.mobile = data;
  },
};

const actions = {
  [types.ACCOUNT_TOKEN]({ commit }, data) {
    commit(types.ACCOUNT_TOKEN, data);
  },
  [types.ACCOUNT_USER_ID]({ commit }, data) {
    commit(types.ACCOUNT_USER_ID, data);
  },
  [types.ACCOUNT_PLAZA_ID]({ commit }, data) {
    commit(types.ACCOUNT_PLAZA_ID, data);
  },
  [types.ACCOUNT_PLAZA_NAME]({ commit }, data) {
    commit(types.ACCOUNT_PLAZA_NAME, data);
  },
  [types.ACCOUNT_ROLE_TYPE]({ commit }, data) {
    commit(types.ACCOUNT_ROLE_TYPE, data);
  },
  [types.ACCOUNT_NAME]({ commit }, data) {
    commit(types.ACCOUNT_NAME, data);
  },
  [types.ACCOUNT_TENANT_ID]({ commit }, data) {
    commit(types.ACCOUNT_TENANT_ID, data);
  },
  [types.ACCOUNT_STORE_ID]({ commit }, data) {
    commit(types.ACCOUNT_STORE_ID, data);
  },
  [types.ACCOUNT_MOBILE]({ commit }, data) {
    commit(types.ACCOUNT_MOBILE, data);
  },
  // [types.ACCOUNT_STORE_NAME]({ commit }, data) {
  //   commit(types.ACCOUNT_STORE_NAME, data);
  // }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
